// Dashboard.js
import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import TopHeader from '../../components/TopHeader';
import CourseCards from '../../components/CourseCards';
import StatusSection from '../../components/StatusSection';
import RankingSection from '../../components/RankingSection';
import ProfileSidebar from '../../components/ProfileSidebar';
import { dashboardService } from '../../services/dashboard.service';

import './Dashboard.css';
import Chart from 'chart.js/auto';
import $ from 'jquery';
import 'datatables.net';

export default function DashboardPage() {
  const [learningStats, setLearningStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentUserPoints, setCurrentUserPoints] = useState(null);

  useEffect(() => {
    const loadLearningStats = async () => {
      try {
        setError(null);
        const stats = await dashboardService.getLearningTimeStats('daily', 7);
        setLearningStats(stats);
      } catch (error) {
        console.error('Failed to load learning stats:', error);
        setError('学習データの読み込みに失敗しました');
        setLearningStats([]);
      } finally {
        setLoading(false);
      }
    };

    loadLearningStats();
  }, []);

  useEffect(() => {
    if (loading) return;

    let chartInstance = null;

    const ctx1 = document.getElementById('learningChart')?.getContext('2d');
    if (ctx1) {
      if (Chart.getChart(ctx1)) {
        Chart.getChart(ctx1).destroy();
      }

      // Prepare chart data from learning stats
      const labels = learningStats.map(stat => {
        const date = new Date(stat.period_date);
        return `${date.getMonth() + 1}/${date.getDate()}`;
      });

      const learningData = learningStats.map(stat => stat.total_minutes || 0);
      const sessionData = learningStats.map(stat => 0); // Temporarily disabled for future test completion implementation

      chartInstance = new Chart(ctx1, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: '視聴時間',
              data: learningData,
              backgroundColor: '#1976d2',
              borderRadius: 6
            },
            {
              label: 'セッション数',
              data: sessionData,
              backgroundColor: '#e3f2fd',
              borderRadius: 6
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: '#2b2b3a',
              titleColor: '#ffffff',
              bodyColor: '#ffffff',
              padding: 10,
              cornerRadius: 4,
              displayColors: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.label}: ${context.parsed.y} 分`;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              min: 0,
              ticks: {
                callback: val => val + ' 分'
              },
              grid: {
                borderDash: [5, 5],
                color: '#ddd'
              }
            },
            x: {
              grid: { display: false }
            }
          }
        }
      });
    }

    const rankingTable = document.getElementById('ranking-table');
    if (rankingTable && $.fn.DataTable) {
      $('#ranking-table').DataTable({
        paging: false,
        searching: false,
        info: false,
        ordering: true,
        order: [[0, 'asc']],
        columnDefs: [
          { targets: 0, orderable: true },
          { targets: [1, 2, 3, 4], orderable: false }
        ],
        language: {
          emptyTable: 'データがありません'
        }
      });
    }

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
      if ($.fn.DataTable && $.fn.DataTable.isDataTable('#ranking-table')) {
        $('#ranking-table').DataTable().destroy();
      }
    };
  }, [loading, learningStats]);

  // StatusSectionで計算されたポイントを受け取る
  const handlePointsCalculated = (points) => {
    setCurrentUserPoints(points);
  };

  return (
    <div className="dashboard">
      <Sidebar />

      <div className="main-content">
        <TopHeader />
        <div className="content-area">
          {error && (
            <div className="error-message" style={{ 
              padding: '10px 20px', 
              margin: '10px 0', 
              backgroundColor: '#fee', 
              color: '#c00', 
              borderRadius: '4px',
              border: '1px solid #fcc'
            }}>
              {error}
            </div>
          )}
          <CourseCards />
          <div className="dashboard-grid">
            <StatusSection 
              learningStats={learningStats} 
              loading={loading} 
              onPointsCalculated={handlePointsCalculated}
            />
            <RankingSection 
              learningStats={learningStats} 
              loading={loading} 
              currentUserPoints={currentUserPoints}
            />
          </div>
        </div>
      </div>

      <ProfileSidebar />
    </div>
  );
}
